
import { Component, Vue } from "vue-property-decorator";
import ActivityDependendViewBase from "@/app/views/activity-dependend-view.base";
import FormWrapper from "@/app/dynamic-components/forms/FormWrapper.vue";
import { dossierServiceV2 } from "@/app/services/dossier.service";
import { DossierCreationModel } from "@/app/models/dossier/creation/dossier-creation.model";
import AcceptPoliciesInterceptor from "@/components/common/AcceptPoliciesInterceptor.vue";
import PageHeader from "@/components/layout/PageHeader.vue";
import AuthenticationInterceptor from "@/components/common/AuthenticationInterceptor.vue";
import router from "@/router";
import DynamicComponentsEntryList from "@/app/components/dynamic-components-entry-list.vue";
import { Subject, Subscription } from "rxjs";
import { formService } from "@/app/services/form.service";
import { RenderType } from "@/app/Types";
import {
  DynamicForm,
  FormEvent,
} from "@/app/dynamic-components/forms/dynamic-form.model";
import { defaultDynamicFormEntry } from "@/app/dynamic-components/dynamic-components.model";
import { ExternalContext } from "@/app/contexts/externalContext";
import analyticsService from "@/services/analytics.service";

@Component({
  computed: {
    RenderType() {
      return RenderType;
    },
  },
  components: {
    DynamicComponentsEntryList,
    AuthenticationInterceptor,
    PageHeader,
    AcceptPoliciesInterceptor,
    FormWrapper,
  },
})
export default class DossiersCreateView extends ActivityDependendViewBase {
  protected dossierDefinitionId = "";
  protected dossierDefinitionCreationModel: DossierCreationModel = {
    form: defaultDynamicFormEntry,
  };
  protected isSaving = false;
  protected formStartTime: number | null = null;

  protected externalContext = new ExternalContext();
  async onPageReady(): Promise<any> {
    this.dossierDefinitionId =
      this.activityDefinition?.dossiers?.entries[0]?.dossierCreationDefinitionId;
    if (this.dossierDefinitionId) {
      dossierServiceV2
        .getDossierCreationDefinition(this.dossierDefinitionId)
        .then((value) => {
          this.dossierDefinitionCreationModel = value;
          this.externalContext.setData("user", this.$store.state.user);
          this.externalContext.setData("activity", this.activityDefinition);
          this.externalContext.setData("activitydefinition", this.activityDefinition);
        })
        .catch((reason) => {
          console.error("Could not find creation definition model", reason);
        });
    }
  }
  mounted(): void {
    this.trackFormStart();
  }

  goBack() {
    router.back();
  }

  formData: any = null;
  formDataChanged(formData: any) {
    this.formData = formData;
  }

  private form: DynamicForm = new DynamicForm({
    id: "",
    children: [],
    name: "",
    type: RenderType.LinearSection,
    displayMode: "editable",
    displayModeRule: "",
    computedValue: "",
    metadata: {},
    watchFormChanges: false
  });

  initializedForm(form: DynamicForm) {
    this.form = form;
  }

  async handleCreateDossier() {
    if(!this.form) return;
    const success = await FormWrapper.SAVE_FORM_ASYNC(this.form, () => this.isSaving = true, () => this.isSaving = false, async (formData, form) => {
      const result = await dossierServiceV2.createNewDossier(formData, this.dossierDefinitionId, form);
      return {
        type: "dossier",
        id: result.data
      }
    });
    if(success){
      Vue.$toast.success("Successfully saved.");
      this.trackFormSubmission();
      this.goBack();
    }
  }
  // Function to track form start time
  trackFormStart() {
    this.formStartTime = Date.now();
    //console.log('trackFormStart');
    analyticsService.sendEvent('Form Interaction', 'dossiers_create_form_open', 'dossiers-create-view Form Opened', 1);
  }

  // Function to track form submission time
  trackFormSubmission() {
    const formEndTime = Date.now();
    if (this.formStartTime) {
      const timeSpent = (formEndTime - this.formStartTime) / 1000; // Convert time spent to seconds
      //console.log('trackFormSubmission timespent: ' + timeSpent);
      analyticsService.sendEvent('Form Interaction', 'dossiers_create_form_submit', 'dossiers-create-view Form Submitted ', 1, {
        time_spent: timeSpent,
      });
    }
  }
}
